/**
 * Estado da camada de raios (Zustand). Registra o codec de URL `x` (o raio)
 * no import — `ui/modules.tsx` importa este arquivo antes de `readUrlState()`.
 */
import { create } from 'zustand';
import { registerUrlCodec } from '../state/urlCodec';
import type { IndiceRaios } from './api';

/** Começa desligada, como as outras camadas extras. */
export const DEFAULT_VISIVEL = false;

export interface Situacao {
  estado: 'idle' | 'loading' | 'ready' | 'error';
  erro: string | null;
}

/**
 * Os raios no quadro exibido: `ok` na tela · `carregando` baixando (fica o
 * anterior) · `sem` nenhum quadro do GLM neste horário · `falhou`.
 */
export interface RaiosNoQuadro {
  estado: 'ok' | 'carregando' | 'sem' | 'falhou';
  /** Início do quadro (epoch ms). */
  t: number | null;
  /** Flashes na tela. */
  n: number;
}

export interface Progresso {
  baixados: number;
  total: number;
  falhas: number;
}

export interface RaiosState {
  visivel: boolean;
  situacao: Situacao;
  indice: IndiceRaios | null;
  noQuadro: RaiosNoQuadro;
  progresso: Progresso;
  setVisivel: (on: boolean) => void;
}

export const useRaiosStore = create<RaiosState>()((set) => ({
  visivel: DEFAULT_VISIVEL,
  situacao: { estado: 'idle', erro: null },
  indice: null,
  noQuadro: { estado: 'sem', t: null, n: 0 },
  progresso: { baixados: 0, total: 0, falhas: 0 },
  setVisivel: (visivel) => set({ visivel }),
}));

registerUrlCodec({
  key: 'x',
  encode: () => (useRaiosStore.getState().visivel ? '1' : null),
  decode: (value) => {
    if (value === '1') useRaiosStore.setState({ visivel: true });
  },
  subscribe: (onChange) =>
    useRaiosStore.subscribe((a, b) => {
      if (a.visivel !== b.visivel) onChange();
    }),
});
